import React, {useEffect, useState} from 'react';
import * as Yup from 'yup';
import {registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond/dist/filepond.min.css';
import AsyncCreatableSelect from "react-select/async-creatable";
import {axiosInstance} from "../../../utils/axiosInstance";
import {InputDatePicker} from "jalaali-react-date-picker";
import "jalaali-react-date-picker/lib/styles/index.css";
import DynamicForm from "../../../components/form/dynamicForm";
import {newsTypeOptions} from "../../../services/types/news";
import {DtPicker} from 'react-calendar-datetime-picker'
import 'react-calendar-datetime-picker/dist/style.css'
import {fetchSingleNews, updateNews} from "../../../services/news";
import Select from "react-select";
import {fetchAllCategories, fetchSingleCategory, updateCategory} from "../../../services/categories";
import type {FieldType, OptionType} from "../../../components/form/types/types";
import {parseIDayToDateStr} from "../../../utils/time";
import {useParams} from "react-router-dom";
// Register FilePond plugins
registerPlugin(FilePondPluginFileValidateType, FilePondPluginImagePreview);

const EditCategories = () => {
    const {id} = useParams()

    useEffect(() => {
        const loadTagsOptions = async () => {
            const tagsSearchResponse = await axiosInstance.get('tags');
            const tags = tagsSearchResponse.data.results;

            const mappedTagOptions = tags.map((tag) => ({
                value: tag.id, label: tag.name, createdAt: tag.created_at
            }));

            setTagsOptions(mappedTagOptions); // Directly store mapped values
        };

        const loadSingleCategory = async () => {
            const newsByIdResponse = await fetchSingleCategory(id);
            const news = newsByIdResponse.data.data;

            const initializedValues = fields.reduce((acc, field) => {
                acc[field.fieldName] = field.getValue ? field.getValue(news) : news[field.fieldName];
                return acc;
            }, {});

            setValues(initializedValues);
            console.log('settings single news', initializedValues);
        };

        const loadCategories = async () => {
            const fetchCategoriesResponse = await fetchAllCategories({page_size: 1000});
            const categoriesOptions = fetchCategoriesResponse.data.results.map((cat) => ({
                value: cat.id, label: cat.name,
            }));

            setCategories(categoriesOptions);
            console.log('categories loaded');
        };
        const loadData = async () => {
            setIsLoading(true); // Start loading data

            try {
                await loadTagsOptions();
                await loadCategories();
                await loadSingleCategory();
            } catch (error) {
                console.error("Error loading data:", error);
            } finally {
                setIsLoading(false); // End loading after all data is fetched
            }
        };

        loadData();

    }, [])
    // tags
    const [tagsOptions, setTagsOptions] = useState([]);
    const [tagsLoading, setTagsLoading] = useState(false)

    const [values, setValues] = useState({})

    const [isLoading, setIsLoading] = useState(true)

    const [categories, setCategories] = useState([])

    // dynamic form
    const meta = {
        gridColumns: {
            small: 1, medium: 3, large: 4
        },
    };

    const fields: FieldType = [{
        displayed: false,
        title: 'عنوان',
        fieldName: 'name',
        type: 'string',
        validation: (value) => Yup.string().max(30).required(),
    }];

    const updateNewsHandler = async (values) => {
        console.log('trying to update');
        await updateCategory(id, values)
    }

    console.log('values', values);
    return (!isLoading && <DynamicForm
        fields={fields}
        meta={meta}
        onSubmit={updateNewsHandler}
        values={values}
    />);


};

export default EditCategories;